export default __webpack_public_path__ + "assets/images/bitcoin-talk-c9dbed7eb5402cc81d432b1b1bfed5f6.svg";